import {

	PlaneBufferGeometry,

	BufferAttribute

} from 'three'


export default class Geometry extends PlaneBufferGeometry {

	constructor(ratio){

		super(2,0.1 * ratio,150,150)

	}

}


// WEBPACK FOOTER //
// ./src/scripts/Trail/modules/trail/geometry.js